module.exports = __webpack_public_path__ + "static/media/YF05_3.91c8d212.jpg";